// Données de réparation reprises de macinfo.fr - à personnaliser selon vos tarifs

export const repairCategories = [
  { id: 'iphone', label: 'iPhone', icon: 'Smartphone', path: '/reparation/iphone' },
  { id: 'mac', label: 'Mac', icon: 'Laptop', path: '/reparation/mac' },
  { id: 'ipad', label: 'iPad', icon: 'Tablet', path: '/reparation/ipad' },
  { id: 'watch', label: 'Apple Watch', icon: 'Watch', path: '/reparation/apple-watch' },
];

export const iphoneData = {
  title: "Réparation iPhone",
  description: "Nos techniciens spécialisés réparent tous les modèles d'iPhone. Écran, batterie, caméra, connecteur de charge — intervention rapide sans rendez-vous.",
  gammes: [
    {
      name: "iPhone 16",
      models: [
        { model: "iPhone 16e", ecran: 229, batterie: 89, connecteur: "Sur devis", vitre_arriere: "Sur devis" },
        { model: "iPhone 16", ecran: 279, batterie: 89, connecteur: "Sur devis", vitre_arriere: 149 },
        { model: "iPhone 16 Plus", ecran: 319, batterie: 89, connecteur: "Sur devis", vitre_arriere: 169 },
        { model: "iPhone 16 Pro", ecran: 379, batterie: 99, connecteur: "Sur devis", vitre_arriere: 199 },
        { model: "iPhone 16 Pro Max", ecran: 429, batterie: 99, connecteur: "Sur devis", vitre_arriere: 219 },
      ]
    },
    {
      name: "iPhone 15",
      models: [
        { model: "iPhone 15", ecran: 229, batterie: 79, connecteur: "Sur devis", vitre_arriere: 129 },
        { model: "iPhone 15 Plus", ecran: 269, batterie: 79, connecteur: "Sur devis", vitre_arriere: 149 },
        { model: "iPhone 15 Pro", ecran: 329, batterie: 89, connecteur: "Sur devis", vitre_arriere: 179 },
        { model: "iPhone 15 Pro Max", ecran: 379, batterie: 89, connecteur: "Sur devis", vitre_arriere: 199 },
      ]
    },
    {
      name: "iPhone 14",
      models: [
        { model: "iPhone 14", ecran: 199, batterie: 79, connecteur: 79, vitre_arriere: 119 },
        { model: "iPhone 14 Plus", ecran: 229, batterie: 79, connecteur: 79, vitre_arriere: 139 },
        { model: "iPhone 14 Pro", ecran: 279, batterie: 89, connecteur: 79, vitre_arriere: 159 },
        { model: "iPhone 14 Pro Max", ecran: 319, batterie: 89, connecteur: 79, vitre_arriere: 179 },
      ]
    },
    {
      name: "iPhone 13",
      models: [
        { model: "iPhone 13", ecran: 169, batterie: 69, connecteur: 69, vitre_arriere: 109 },
        { model: "iPhone 13 Mini", ecran: 149, batterie: 69, connecteur: 69, vitre_arriere: 99 },
        { model: "iPhone 13 Pro", ecran: 229, batterie: 79, connecteur: 69, vitre_arriere: 139 },
        { model: "iPhone 13 Pro Max", ecran: 259, batterie: 79, connecteur: 69, vitre_arriere: 159 },
      ]
    },
    {
      name: "iPhone 12",
      models: [
        { model: "iPhone 12", ecran: 149, batterie: 69, connecteur: 69, vitre_arriere: 99 },
        { model: "iPhone 12 Mini", ecran: 139, batterie: 69, connecteur: 69, vitre_arriere: 89 },
        { model: "iPhone 12 Pro", ecran: 189, batterie: 79, connecteur: 69, vitre_arriere: 119 },
        { model: "iPhone 12 Pro Max", ecran: 219, batterie: 79, connecteur: 69, vitre_arriere: 139 },
      ]
    },
    {
      name: "iPhone 11",
      models: [
        { model: "iPhone 11", ecran: 89, batterie: 59, connecteur: 59, vitre_arriere: 99 },
        { model: "iPhone 11 Pro", ecran: 109, batterie: 59, connecteur: 59, vitre_arriere: 99 },
        { model: "iPhone 11 Pro Max", ecran: 109, batterie: 59, connecteur: 59, vitre_arriere: 99 },
      ]
    },
    {
      name: "iPhone X / XS / XR",
      models: [
        { model: "iPhone X", ecran: 99, batterie: 59, connecteur: 59, vitre_arriere: 69 },
        { model: "iPhone XS", ecran: 99, batterie: 59, connecteur: 59, vitre_arriere: 69 },
        { model: "iPhone XS Max", ecran: 109, batterie: 59, connecteur: 59, vitre_arriere: 99 },
        { model: "iPhone XR", ecran: 89, batterie: 59, connecteur: 59, vitre_arriere: "Sur devis" },
      ]
    },
    {
      name: "iPhone SE",
      models: [
        { model: "iPhone SE (2022)", ecran: 99, batterie: 49, connecteur: 39, vitre_arriere: "Sur devis" },
        { model: "iPhone SE (2020)", ecran: 79, batterie: 49, connecteur: 39, vitre_arriere: "Sur devis" },
        { model: "iPhone SE (2016)", ecran: 49, batterie: 39, connecteur: 39, vitre_arriere: "Sur devis" },
      ]
    },
    {
      name: "iPhone 8",
      models: [
        { model: "iPhone 8", ecran: 55, batterie: 49, connecteur: 39, vitre_arriere: "Sur devis" },
        { model: "iPhone 8 Plus", ecran: 55, batterie: 49, connecteur: 39, vitre_arriere: "Sur devis" },
      ]
    },
    {
      name: "iPhone 7",
      models: [
        { model: "iPhone 7", ecran: 69, batterie: 39, connecteur: 39, vitre_arriere: "Sur devis" },
        { model: "iPhone 7 Plus", ecran: 79, batterie: 39, connecteur: 39, vitre_arriere: "Sur devis" },
      ]
    },
    {
      name: "iPhone 6",
      models: [
        { model: "iPhone 6", ecran: 49, batterie: 39, connecteur: 39, vitre_arriere: "Sur devis" },
        { model: "iPhone 6 Plus", ecran: 55, batterie: 39, connecteur: 39, vitre_arriere: "Sur devis" },
        { model: "iPhone 6S", ecran: 55, batterie: 39, connecteur: 39, vitre_arriere: "Sur devis" },
        { model: "iPhone 6S Plus", ecran: 59, batterie: 39, connecteur: 39, vitre_arriere: "Sur devis" },
      ]
    },
  ],
  services: [
    "Remplacement écran",
    "Remplacement batterie",
    "Réparation connecteur de charge",
    "Remplacement caméra",
    "Réparation Face ID / Touch ID",
    "Remplacement vitre arrière",
    "Diagnostic complet",
    "Récupération de données",
  ]
};

export const macServices = [
  { label: "Récupération de données", price: "99€", icon: "💾" },
  { label: "Suppression Virus / Malwares", price: "99€", icon: "🛡" },
  { label: "Panne liquide (dommage eau)", price: "159€", icon: "💧" },
  { label: "Installation / Restauration macOS", price: "49€", icon: "🖥" },
  { label: "Ajout / Remplacement RAM", price: "189€", icon: "🔧" },
  { label: "Remplacement SSD", price: "199€", icon: "💿" },
  { label: "Réparation clavier MacBook Air", price: "À partir de 189€", icon: "⌨️" },
  { label: "Réparation clavier MacBook Pro", price: "À partir de 239€", icon: "⌨️" },
  { label: "Réparation clavier iMac", price: "249€", icon: "⌨️" },
  { label: "Déblocage EFI & iCloud (2007–2010)", price: "100€", icon: "🔓" },
  { label: "Déblocage EFI & iCloud (2011–2015)", price: "140€", icon: "🔓" },
  { label: "Déblocage EFI & iCloud (2016–2019)", price: "180€", icon: "🔓" },
  { label: "Déblocage EFI & iCloud (2020–2026)", price: "280€", icon: "🔐" },
];

export const macData = {
  title: "Réparation Mac",
  description: "Réparation MacBook Air, MacBook Pro, iMac et Mac Mini. Nos techniciens interviennent sur toutes les pannes : écran, batterie, clavier, carte mère, SSD.",
  gammes: [
    {
      name: "MacBook Air",
      models: [
        { model: "MacBook Air 13\" M4 (A3280)", efi: 280, ecran: 399, batterie: 189, clavier: 279 },
        { model: "MacBook Air 15\" M3 (A3114)", efi: 280, ecran: 449, batterie: 199, clavier: 299 },
        { model: "MacBook Air 13\" M3 (A3113)", efi: 280, ecran: 379, batterie: 179, clavier: 259 },
        { model: "MacBook Air 13\" M2 (A2681)", efi: 280, ecran: 349, batterie: 169, clavier: 249 },
        { model: "MacBook Air 13\" M1 (A2337)", efi: 280, ecran: 329, batterie: 159, clavier: 239 },
        { model: "MacBook Air 13\" (A2179)", efi: 280, ecran: 299, batterie: 149, clavier: 229 },
        { model: "MacBook Air 13\" (A1932)", efi: 180, ecran: 279, batterie: 149, clavier: 229 },
        { model: "MacBook Air 13\" (A1466)", efi: 180, ecran: 249, batterie: 129, clavier: 199 },
        { model: "MacBook Air 11\" (A1465)", efi: 140, ecran: 229, batterie: 119, clavier: 189 },
      ]
    },
    {
      name: "MacBook Pro",
      models: [
        { model: "MacBook Pro 16\" M4 (A3403)", efi: 280, ecran: 599, batterie: 229, clavier: 349 },
        { model: "MacBook Pro 14\" M4 (A3401)", efi: 280, ecran: 549, batterie: 219, clavier: 329 },
        { model: "MacBook Pro 16\" M3 (A2991)", efi: 280, ecran: 579, batterie: 219, clavier: 339 },
        { model: "MacBook Pro 14\" M3 (A2992)", efi: 280, ecran: 529, batterie: 209, clavier: 319 },
        { model: "MacBook Pro 13\" M2 (A2338)", efi: 280, ecran: 449, batterie: 199, clavier: 299 },
        { model: "MacBook Pro 13\" M1 (A2338)", efi: 280, ecran: 429, batterie: 189, clavier: 279 },
        { model: "MacBook Pro 13\" (A2289)", efi: 280, ecran: 399, batterie: 179, clavier: 269 },
        { model: "MacBook Pro 13\" (A1989)", efi: 180, ecran: 369, batterie: 169, clavier: 249 },
        { model: "MacBook Pro 15\" (A1990)", efi: 180, ecran: 469, batterie: 199, clavier: 299 },
        { model: "MacBook Pro 13\" (A1706)", efi: 180, ecran: 349, batterie: 159, clavier: 239 },
        { model: "MacBook Pro 15\" (A1707)", efi: 180, ecran: 429, batterie: 189, clavier: 279 },
      ]
    },
    {
      name: "iMac",
      models: [
        { model: "iMac 24\" M4 (A3247)", efi: 280, ecran: 699, batterie: "N/A", clavier: 249 },
        { model: "iMac 24\" M3 (A2873)", efi: 280, ecran: 649, batterie: "N/A", clavier: 249 },
        { model: "iMac 24\" M1 (A2438)", efi: 280, ecran: 599, batterie: "N/A", clavier: 249 },
        { model: "iMac 27\" (A2115)", efi: 180, ecran: 749, batterie: "N/A", clavier: 269 },
        { model: "iMac 21,5\" (A2116 4K)", efi: 180, ecran: 549, batterie: "N/A", clavier: 229 },
        { model: "iMac 21,5\" (A1418)", efi: 180, ecran: 449, batterie: "N/A", clavier: 199 },
      ]
    },
  ],
  services: [
    "Remplacement écran MacBook",
    "Remplacement batterie MacBook",
    "Remplacement SSD / Disque dur",
    "Réparation carte mère",
    "Nettoyage et entretien ventilateur",
    "Réparation trackpad",
    "Diagnostic & mise à jour",
  ]
};

export const ipadData = {
  title: "Réparation iPad",
  description: "Réparation iPad par des techniciens spécialisés Apple. Vitre, écran LCD, batterie — devis gratuit et intervention rapide sous 24 à 48h.",
  gammes: [
    {
      name: "iPad Pro",
      models: [
        { model: "iPad Pro 13\" M4", ecran: 549, batterie: 149, connecteur: 99, vitre_arriere: "Sur devis"},
        { model: "iPad Pro 11\" M4", ecran: 449, batterie: 149, connecteur: 99, vitre_arriere: "Sur devis"},
        { model: "iPad Pro 12,9\" 3/4 Gen", ecran: 299, batterie: 129, connecteur: 99, vitre_arriere: "Sur devis"},
        { model: "iPad Pro 11\" 1/2 Gen 2018-2020", ecran: 299, batterie: 129, connecteur: 99, vitre_arriere: "Sur devis"},
        { model: "iPad Pro 10,5\"", ecran: 249, batterie: 109, connecteur: 99, vitre_arriere: 159},
        { model: "iPad Pro 9,7\"", ecran: 169, batterie: 99, connecteur: 99, vitre_arriere: 119},
      ]
    },
    {
      name: "iPad Air",
      models: [
        { model: "iPad Air 13\" M2/M3", ecran: 449, batterie: 149, connecteur: 99, vitre_arriere: "Sur devis"},
        { model: "iPad Air 11\" M2/M3", ecran: 349, batterie: 139, connecteur: 99, vitre_arriere: "Sur devis"},
        { model: "iPad Air 5", ecran: 299, batterie: 129, connecteur: 99, vitre_arriere: 189},
        { model: "iPad Air 4", ecran: 279, batterie: 119, connecteur: 99, vitre_arriere: 179},
        { model: "iPad Air 3", ecran: 209, batterie: 109, connecteur: 99, vitre_arriere: 139},
        { model: "iPad Air 2", ecran: 179, batterie: 99, connecteur: 99, vitre_arriere: 109},
        { model: "iPad Air 1", ecran: 109, batterie: 89, connecteur: 99, vitre_arriere: 69},
      ]
    },
    {
      name: "iPad (standard)",
      models: [
        { model: "iPad 10 (2022)", ecran: 249, batterie: 119, connecteur: 79, vitre_arriere: 139},
        { model: "iPad 9 (2021)", ecran: 139, batterie: 89, connecteur: 79, vitre_arriere: 89},
        { model: "iPad 8 (2020)", ecran: 139, batterie: 89, connecteur: 79, vitre_arriere: 89},
        { model: "iPad 7 (2019)", ecran: 139, batterie: 89, connecteur: 79, vitre_arriere: 89},
        { model: "iPad 6 (2018)", ecran: 109, batterie: 89, connecteur: 79, vitre_arriere: 69},
        { model: "iPad 5 (2017)", ecran: 109, batterie: 89, connecteur: 79, vitre_arriere: 69},
        { model: "iPad 4", ecran: 99, batterie: 89, connecteur: 79, vitre_arriere: 59},
        { model: "iPad 3", ecran: 99, batterie: 89, connecteur: 79, vitre_arriere: 59},
      ]
    },
    {
      name: "iPad mini",
      models: [
        { model: "iPad mini 6", ecran: 299, batterie: 119, connecteur: 79, vitre_arriere: "Sur devis"},
        { model: "iPad mini 5", ecran: 199, batterie: 109, connecteur: 79, vitre_arriere: 139},
      ]
    },
  ],
  services: [
    "Remplacement écran / vitre tactile",
    "Remplacement batterie",
    "Réparation connecteur de charge",
    "Remplacement caméra",
    "Réparation Touch ID",
    "Diagnostic et récupération de données",
  ]
};

export const watchData = {
  title: "Réparation Apple Watch",
  description: "Réparation Apple Watch toutes séries. Écran cassé, batterie défectueuse, Apple Watch qui ne s'allume plus — nos techniciens s'occupent de tout.",
  gammes: [
    {
      name: "Apple Watch Series 9 / Ultra",
      models: [
        { model: "Apple Watch Ultra 2", ecran: 349, batterie: 149 },
        { model: "Apple Watch Ultra", ecran: 329, batterie: 149 },
        { model: "Apple Watch Series 9 (45mm)", ecran: 249, batterie: 119 },
        { model: "Apple Watch Series 9 (41mm)", ecran: 229, batterie: 109 },
      ]
    },
    {
      name: "Apple Watch Series 7 / 8",
      models: [
        { model: "Apple Watch Series 8 (45mm)", ecran: 229, batterie: 109 },
        { model: "Apple Watch Series 8 (41mm)", ecran: 209, batterie: 99 },
        { model: "Apple Watch Series 7 (45mm)", ecran: 199, batterie: 109 },
        { model: "Apple Watch Series 7 (41mm)", ecran: 179, batterie: 99 },
      ]
    },
    {
      name: "Apple Watch Series 4 / 5 / 6",
      models: [
        { model: "Apple Watch Series 6 (44mm)", ecran: 179, batterie: 99 },
        { model: "Apple Watch Series 6 (40mm)", ecran: 159, batterie: 89 },
        { model: "Apple Watch Series 5 (44mm)", ecran: 179, batterie: 99 },
        { model: "Apple Watch Series 5 (40mm)", ecran: 159, batterie: 89 },
        { model: "Apple Watch Series 4 (44mm)", ecran: 149, batterie: 89 },
        { model: "Apple Watch Series 4 (40mm)", ecran: 139, batterie: 79 },
      ]
    },
    {
      name: "Apple Watch SE / Series 1 / 2 / 3",
      models: [
        { model: "Apple Watch SE 2 (44mm)", ecran: 179, batterie: 89 },
        { model: "Apple Watch SE 2 (40mm)", ecran: 159, batterie: 79 },
        { model: "Apple Watch SE (44mm)", ecran: 149, batterie: 89 },
        { model: "Apple Watch SE (40mm)", ecran: 129, batterie: 79 },
        { model: "Apple Watch Series 3 (42mm)", ecran: 119, batterie: 79 },
        { model: "Apple Watch Series 3 (38mm)", ecran: 99, batterie: 79 },
        { model: "Apple Watch Series 2 (42mm)", ecran: 109, batterie: 79 },
        { model: "Apple Watch Series 1 (42mm)", ecran: 99, batterie: 79 },
      ]
    },
  ],
  services: [
    "Remplacement écran Apple Watch",
    "Remplacement batterie Apple Watch",
    "Réparation Apple Watch qui ne s'allume plus",
    "Diagnostic Apple Watch",
  ]
};

export const testimonials = [
  {
    name: "aucleamyproductions",
    rating: 5,
    text: "Changement de l'écran et de la batterie qui avait gonflé sur un MacBook Pro. Très sérieux, professionnel, efficace et rapide. Je le recommande !",
    location: "Pages Jaunes",
    date: "Sept. 2025",
  },
  {
    name: "mnora",
    rating: 5,
    text: "Accueil incroyable. Sofiane à l'écoute des gens et très investi dans son métier. Service rapide et très satisfait de la réparation de mon Mac. Je recommande vivement.",
    location: "Pages Jaunes",
    date: "Mai 2024",
  },
  {
    name: "Carol",
    rating: 5,
    text: "J'ai fait le déplacement de Meudon pour aller chez ce prestataire. Le gérant m'a accueillie avec le sourire et a été très à l'écoute. Expert en son domaine, il m'a réparé mon MacBook Pro en un temps record. Merci infiniment !",
    location: "Pages Jaunes",
    date: "Avr. 2024",
  },
  {
    name: "Quentinou",
    rating: 5,
    text: "Très professionnel et rapide. Je recommande.",
    location: "Pages Jaunes",
    date: "Déc. 2023",
  },
  {
    name: "ClaudeFanjeaux",
    rating: 5,
    text: "J'ai été très bien reçu par deux techniciens qui en quelques manipulations ont rendu mon ordinateur en état de marche, gracieusement. Merci à eux.",
    location: "Pages Jaunes",
    date: "Avr. 2021",
  },
  {
    name: "fabramonet",
    rating: 5,
    text: "Vraiment très sympathique, très professionnelle, très honnête, très humaine. Le rêve d'un client. Je recommande complètement cette boutique. — Fabienne",
    location: "Pages Jaunes",
    date: "Juil. 2020",
  },
  {
    name: "Profil056533",
    rating: 5,
    text: "Accueil sympathique. Personne très disponible, professionnelle et honnête.",
    location: "Pages Jaunes",
    date: "Oct. 2020",
  },
];

export const trustBadges = [
  { icon: "Shield", title: "Pièces de qualité", desc: "Composants certifiés pour une durabilité maximale" },
  { icon: "Clock", title: "Réparation rapide", desc: "La plupart des interventions le jour même" },
  { icon: "Wrench", title: "Techniciens experts", desc: "Spécialisés Apple depuis plus de 5 ans" },
  { icon: "Star", title: "Diagnostic gratuit", desc: "Évaluation sans engagement avant toute réparation" },
];
